export enum CurriculumLevel 
{
    Basic = 1,
    Intermediate = 2, 
    Advanced = 3,
    Native =4

}